<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/admin/users' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="item.path">
      {{ item.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const breadcrumbs = ref([])

// 生成面包屑
const getBreadcrumbs = () => {
  // 不显示首页的面包屑
  if (route.path === '/admin/users') {
    breadcrumbs.value = []
    return
  }
  
  // 根据路由匹配的路径生成面包屑
  const matched = route.matched.filter(item => item.meta && item.meta.title)
  
  // 过滤掉布局组件
  const filteredMatched = matched.filter(item => item.path !== '/admin')
  
  breadcrumbs.value = filteredMatched.map(item => {
    return {
      path: item.path,
      title: item.meta.title
    }
  })
}

// 监听路由变化，更新面包屑
watch(
  () => route.path,
  () => {
    getBreadcrumbs()
  },
  { immediate: true }
)
</script>

<style scoped>
.el-breadcrumb {
  line-height: 60px;
  font-size: 14px;
}
</style> 